import React from 'react';

import Pagination from '@material-ui/lab/Pagination';
import pageMeta from '../../models/pagemeta.model';

interface paginateProps{
  meta:pageMeta,
  paginate:(page:number)=>void
}

const  Paginate:React.FC<paginateProps> = props =>{

  const {meta,paginate} = props;

  const handleChange = (event: React.ChangeEvent<unknown>, value: number)=>{
    paginate(value);
  };

  const calculateTotalPages = () =>{
    const exactValue =  meta.total/meta.per_page;
    const floorValue = Math.floor(exactValue);
    if(exactValue>floorValue){
      return floorValue+1;
    }
    return floorValue;
  }

  return (
    <>
    { meta?
      <Pagination count={calculateTotalPages()} page={meta.current_page} onChange={handleChange} className="ecn-paginated" />
      :""
    }
    </>
  );
}

export default Paginate;